import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find-index";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source), true)).call(_context3, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context4; _forEachInstanceProperty(_context4 = ownKeys(Object(source))).call(_context4, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useRef, useLayoutEffect, useState, useEffect } from 'react';
import Box from '@rexlabs/box';
import { styled, StyleSheet, icon, border, padding, margin } from '@rexlabs/styling';
import Tab from './tab';
import ChevronDownIcon from '@rexlabs/icons/medium/chevron-down.svg';
import PreviousIcon from '@rexlabs/icons/large/chevron-left.svg';
import NextIcon from '@rexlabs/icons/large/chevron-right.svg';
var defaultStyles = StyleSheet({
  container: {
    position: 'relative'
  },
  containerInner: {
    width: '100%',
    position: 'relative',
    overflow: 'hidden'
  },
  list: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    position: 'relative'
  },
  indicator: {
    height: function height(_ref) {
      var token = _ref.token;
      return token('tabs.tabBar.indicator.height', '.2rem');
    },
    width: '.1rem',
    transformOrigin: '0 0',
    position: 'absolute',
    bottom: 0,
    left: 0,
    background: function background(_ref2) {
      var token = _ref2.token;
      return token('tabs.tabBar.indicator.background.color', token('color.primary.idle.default', 'black'));
    }
  },
  navButton: _objectSpread(_objectSpread(_objectSpread({
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    cursor: 'pointer'
  }, padding.styles({
    target: 'tabs.tabBar.navButton',
    x: 'xs',
    y: 's'
  })), border.styles({
    target: 'tabs.tabBar.navButton',
    all: {
      width: 'none'
    },
    bottom: {
      width: 'thin',
      color: function color() {
        return 'transparent';
      }
    }
  })), {}, {
    background: function background(_ref3) {
      var token = _ref3.token;
      return token('tabs.tab.background.color', token('color.container.interactive.idle'));
    },
    color: function color(_ref4) {
      var token = _ref4.token;
      return token('tabs.tabBar.navButton.color', token('color.textStyle.body.subtext'));
    },
    '&:hover': {
      color: function color(_ref5) {
        var token = _ref5.token;
        return token('tabs.tabBar.navButton.hover.color', token('color.textStyle.primary.hover.default'));
      }
    },
    '& > svg': _objectSpread({}, icon.styles({
      target: 'tabs.tabBar.navButton',
      size: 'l'
    })),
    '&[disabled]': {
      cursor: 'default',
      opacity: function opacity(_ref6) {
        var token = _ref6.token;
        return token('tabs.tabBar.navButton.disabled.opacity', 0.5);
      },
      '&:hover': {
        color: function color(_ref7) {
          var token = _ref7.token;
          return token('tabs.tabBar.navButton.disabled.hover.color', token('color.textStyle.body.subtext'));
        }
      }
    }
  }),
  navPrevious: _objectSpread({}, margin.styles({
    target: 'tabs.tabBar.navButton.previous',
    right: 's'
  })),
  navNext: _objectSpread({}, margin.styles({
    target: 'tabs.tabBar.navButton.next',
    left: 's'
  }))
});

function TabBar(_ref8) {
  var activeTab = _ref8.activeTab,
      items = _ref8.items,
      onChange = _ref8.onChange,
      overflowIntoActionMenu = _ref8.overflowIntoActionMenu,
      s = _ref8.styles;
  var initalCalcDone = useRef();
  var containerRef = useRef();
  var containerInnerRef = useRef();
  /**
   * Activate tab on click
   */

  function handleTabClick(_ref9) {
    var name = _ref9.name;
    var element = containerInnerRef.current.querySelector("[data-tab-name=\"".concat(name, "\"]"));
    element === null || element === void 0 ? void 0 : element.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center'
    });
    onChange === null || onChange === void 0 ? void 0 : onChange({
      name: name,
      newIndex: _findIndexInstanceProperty(items).call(items, function (i) {
        return i.name === name;
      }),
      oldIndex: _findIndexInstanceProperty(items).call(items, function (i) {
        return i.name === activeTab;
      })
    });
  }
  /**
   * Tabs scrolling behaviour
   */


  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showPrev = _useState2[0],
      setShowPrev = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showNext = _useState4[0],
      setShowNext = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showNavButtons = _useState6[0],
      setShowNavButtons = _useState6[1];

  useEffect(function () {
    if (overflowIntoActionMenu) {
      return;
    }

    var element = containerInnerRef.current;

    function handleScroll() {
      setShowPrev((element === null || element === void 0 ? void 0 : element.scrollLeft) > 0);
      setShowNext((element === null || element === void 0 ? void 0 : element.scrollLeft) < (element === null || element === void 0 ? void 0 : element.scrollWidth) - (element === null || element === void 0 ? void 0 : element.offsetWidth));
    }

    var resizeObserver = new ResizeObserver(function (entries) {
      var _entries$;

      var el = (_entries$ = entries[0]) === null || _entries$ === void 0 ? void 0 : _entries$.target;
      setShowPrev((el === null || el === void 0 ? void 0 : el.scrollLeft) > 0);
      setShowNext((el === null || el === void 0 ? void 0 : el.scrollLeft) < (el === null || el === void 0 ? void 0 : el.scrollWidth) - (el === null || el === void 0 ? void 0 : el.offsetWidth));
      setShowNavButtons((el === null || el === void 0 ? void 0 : el.clientWidth) < (el === null || el === void 0 ? void 0 : el.scrollWidth));
    });
    resizeObserver.observe(element);
    handleScroll();
    element === null || element === void 0 ? void 0 : element.addEventListener('scroll', handleScroll);
    return function () {
      resizeObserver.unobserve(element);
      element === null || element === void 0 ? void 0 : element.removeEventListener('scroll', handleScroll);
    };
  }, [overflowIntoActionMenu]);

  function handlePreviousClick() {
    var _containerInnerRef$cu, _containerInnerRef$cu2;

    (_containerInnerRef$cu = containerInnerRef.current) === null || _containerInnerRef$cu === void 0 ? void 0 : _containerInnerRef$cu.scrollTo({
      left: Math.max(((_containerInnerRef$cu2 = containerInnerRef.current) === null || _containerInnerRef$cu2 === void 0 ? void 0 : _containerInnerRef$cu2.scrollLeft) - 100, 0),
      behavior: 'smooth'
    });
  }

  function handleNextClick() {
    var _containerInnerRef$cu3, _containerInnerRef$cu4, _containerInnerRef$cu5, _containerInnerRef$cu6;

    (_containerInnerRef$cu3 = containerInnerRef.current) === null || _containerInnerRef$cu3 === void 0 ? void 0 : _containerInnerRef$cu3.scrollTo({
      left: Math.min(((_containerInnerRef$cu4 = containerInnerRef.current) === null || _containerInnerRef$cu4 === void 0 ? void 0 : _containerInnerRef$cu4.scrollLeft) + 100, ((_containerInnerRef$cu5 = containerInnerRef.current) === null || _containerInnerRef$cu5 === void 0 ? void 0 : _containerInnerRef$cu5.scrollWidth) - ((_containerInnerRef$cu6 = containerInnerRef.current) === null || _containerInnerRef$cu6 === void 0 ? void 0 : _containerInnerRef$cu6.offsetWidth)),
      behavior: 'smooth'
    });
  }
  /**
   * Overflow to action menu calculations
   */


  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      overflownTabs = _useState8[0],
      setOverflownTabs = _useState8[1];

  useLayoutEffect(function () {
    var _window;

    if (!overflowIntoActionMenu) {
      return;
    }

    if (!((_window = window) === null || _window === void 0 ? void 0 : _window.ResizeObserver)) {
      // TODO: handle via window resize?!
      return;
    }

    var resizeObserver = new ResizeObserver(function () {
      setOverflownTabs([]);
    });
    var element = containerRef.current;
    resizeObserver.observe(element);
    return function () {
      return resizeObserver.unobserve(element);
    };
  }, [overflowIntoActionMenu, activeTab]);
  useLayoutEffect(function () {
    var _containerInnerRef$cu7, _containerInnerRef$cu8;

    if (!overflowIntoActionMenu) {
      return;
    }

    if (((_containerInnerRef$cu7 = containerInnerRef.current) === null || _containerInnerRef$cu7 === void 0 ? void 0 : _containerInnerRef$cu7.offsetWidth) < ((_containerInnerRef$cu8 = containerInnerRef.current) === null || _containerInnerRef$cu8 === void 0 ? void 0 : _containerInnerRef$cu8.scrollWidth) && overflownTabs.length < items.length - 1) {
      var nonActive = _filterInstanceProperty(items).call(items, function (tab) {
        return tab.name !== activeTab && !_includesInstanceProperty(overflownTabs).call(overflownTabs, tab.name);
      });

      setOverflownTabs(function (state) {
        var _context, _nonActive;

        return _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(state), [(_nonActive = nonActive[nonActive.length - 1]) === null || _nonActive === void 0 ? void 0 : _nonActive.name]);
      });
    }
  }, [activeTab, overflownTabs, overflowIntoActionMenu, items.length, items]);
  /**
   * Indicator styles calculations
   */

  var _useState9 = useState({}),
      _useState10 = _slicedToArray(_useState9, 2),
      indicatorStyles = _useState10[0],
      setIndicatorStyles = _useState10[1];

  useLayoutEffect(function () {
    var _context2;

    var activeTabElement = containerInnerRef.current.querySelector("[data-tab-name=\"".concat(activeTab, "\"]"));

    if (!activeTabElement) {
      return;
    }

    var left = activeTabElement.offsetLeft;
    var width = activeTabElement.offsetWidth;
    setIndicatorStyles({
      transform: _concatInstanceProperty(_context2 = "translateX(".concat(left, "px) scaleX(")).call(_context2, width, ")"),
      transition: initalCalcDone.current ? 'transform 150ms ease-out' : undefined
    });

    if (!initalCalcDone.current) {
      activeTabElement === null || activeTabElement === void 0 ? void 0 : activeTabElement.scrollIntoView({
        inline: 'center'
      });
    }

    initalCalcDone.current = true;
  }, // eslint-disable-next-line
  [activeTab, overflownTabs]);
  /**
   * Render
   */

  var tabs = _filterInstanceProperty(items).call(items, function (item) {
    return item.type !== 'actionMenu' && (!_includesInstanceProperty(overflownTabs).call(overflownTabs, item.name) || item.name === activeTab);
  });

  var actionMenuTabs = _filterInstanceProperty(items).call(items, function (item) {
    return !_findInstanceProperty(tabs).call(tabs, function (tab) {
      return tab.name === item.name;
    });
  });

  return /*#__PURE__*/React.createElement(Box, _extends({}, s('container'), {
    ref: containerRef,
    alignItems: "center"
  }), !overflowIntoActionMenu && showNavButtons && /*#__PURE__*/React.createElement("button", _extends({}, s('navButton', 'navPrevious'), {
    type: "button",
    disabled: !showPrev,
    onClick: handlePreviousClick
  }), /*#__PURE__*/React.createElement(PreviousIcon, null)), /*#__PURE__*/React.createElement("div", _extends({}, s('containerInner'), {
    ref: containerInnerRef
  }), /*#__PURE__*/React.createElement("ul", _extends({}, s('list'), {
    role: "tablist"
  }), _mapInstanceProperty(tabs).call(tabs, function (_ref10) {
    var name = _ref10.name,
        label = _ref10.label,
        isDisabled = _ref10.isDisabled;
    return /*#__PURE__*/React.createElement(Tab, {
      key: name,
      isDisabled: isDisabled,
      name: name,
      label: label,
      isActive: name === activeTab,
      onClick: handleTabClick
    });
  }), !!actionMenuTabs.length && /*#__PURE__*/React.createElement(Tab, {
    key: "__overflow",
    label: "More",
    items: _mapInstanceProperty(actionMenuTabs).call(actionMenuTabs, function (_ref11) {
      var label = _ref11.label,
          name = _ref11.name;
      return {
        label: label,
        onClick: function onClick() {
          return handleTabClick({
            name: name
          });
        }
      };
    }),
    Icon: ChevronDownIcon
  })), /*#__PURE__*/React.createElement("div", s.with('indicator')(indicatorStyles))), !overflowIntoActionMenu && showNavButtons && /*#__PURE__*/React.createElement("button", _extends({}, s('navButton', 'navNext'), {
    type: "button",
    disabled: !showNext,
    onClick: handleNextClick
  }), /*#__PURE__*/React.createElement(NextIcon, null)));
}

export default styled(defaultStyles)(TabBar);